import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { BrowserModule } from '@angular/platform-browser';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { HttpClientModule } from '@angular/common/http';

import {
  ToolbarModule,
  TabsModule,
  FilterModule,
  PaginationModule,
  OrdersModule,
  SettingsModule,
  TableModule,
} from 'beyond-util';
import { OdlukeComponent } from './odluke.component';

@NgModule({
  imports: [
    CommonModule,
    BrowserModule,
    FormsModule,
    ReactiveFormsModule,
    HttpClientModule,
    TabsModule,
    FilterModule,
    PaginationModule,
    OrdersModule,
    SettingsModule,
    ToolbarModule,
    TableModule,
  ],
  declarations: [OdlukeComponent],
  entryComponents: [OdlukeComponent],
  exports: [OdlukeComponent],
  providers: [],
})
export class OdlukeModule {}



// WEBPACK FOOTER //
// ./src/app/pages/sifarnici/odluke/odluke.module.ts